var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidEdge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.046,
    height: 64.494,
    viewBox: "0 0 54.046 64.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355",
    transform: "translate(-1150.977 -163.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353",
    transform: "translate(11.26 5.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 1161.241, 158.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    transform: "matrix(0.469, 0.883, -0.883, 0.469, 7.951, 0)",
    fill: "#fff",
    stroke: "#f85959",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 4.503,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 3.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M12,0,7.3.053C5.733.071,0,.081,0,.081",
    transform: "matrix(0.017, 1, -1, 0.017, 6.321, 9.819)",
    fill: "none",
    stroke: "#f85959",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(1165.584 206.549) rotate(103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114-2",
    "data-name": "Ellipse 114",
    transform: "translate(11.257 12.864)",
    fill: "#fff",
    stroke: "#f85959",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.503,
    cy: 4.503,
    rx: 4.503,
    ry: 4.503,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.503,
    cy: 4.503,
    rx: 3.003,
    ry: 3.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-2",
    "data-name": "Path 3725",
    d: "M0,0S3.132,6.793,4.7,10.388s7.288,5.569,7.288,5.569",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f85959",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350",
    transform: "translate(1139.717 166.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114-3",
    "data-name": "Ellipse 114",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#f85959",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 4.503,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 3.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-3",
    "data-name": "Path 3725",
    d: "M9.746,13.292S7.2,7.633,5.927,4.639,0,0,0,0",
    transform: "translate(8.278 5.913)",
    fill: "none",
    stroke: "#f85959",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    transform: "translate(1175.739 166.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114-4",
    "data-name": "Ellipse 114",
    transform: "translate(9.019 0)",
    fill: "#fff",
    stroke: "#f85959",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 4.503,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 3.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-4",
    "data-name": "Path 3725",
    d: "M0,13.292S2.547,7.633,3.819,4.639,9.746,0,9.746,0",
    transform: "translate(0 5.913)",
    fill: "none",
    stroke: "#f85959",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349",
    transform: "translate(1189.205 201.629) rotate(77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_114-5",
    "data-name": "Ellipse 114",
    transform: "translate(11.257 0)",
    fill: "#fff",
    stroke: "#f85959",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 4.503,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.503,
    cy: 4.503,
    r: 3.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-5",
    "data-name": "Path 3725",
    d: "M0,15.957S3.132,9.164,4.7,5.57,11.984,0,11.984,0",
    transform: "translate(0 5.913)",
    fill: "none",
    stroke: "#f85959",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(1145.558 173.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M113.771,155.433v20.783a2.639,2.639,0,0,0,2.645,2.9H118.6a1.605,1.605,0,0,0-.243.821v5.886a3.068,3.068,0,0,0,6.111,0v-5.886a1.512,1.512,0,0,0-.367-.821h5.32a1.512,1.512,0,0,0-.369.821v5.886a3.068,3.068,0,0,0,6.111,0v-5.886a1.606,1.606,0,0,0-.242-.821H137.1a2.636,2.636,0,0,0,2.641-2.9V155.433H113.771Z",
    transform: "translate(-105.368 -140.592)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M30.483,158.977a3,3,0,0,0-3.055,2.786v11.928a3.068,3.068,0,0,0,6.111,0V161.764A3,3,0,0,0,30.483,158.977Z",
    transform: "translate(-27.428 -143.797)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M131.393,4.016l.533-.782.534-.773L133.65.723a.454.454,0,0,0-.132-.644.48.48,0,0,0-.659.13l-1.816,2.645-.546.8a16.38,16.38,0,0,0-11.358,0l-.543-.8-.537-.781L116.783.21a.488.488,0,0,0-.664-.13.459.459,0,0,0-.133.644l1.189,1.739.534.774.536.78c-4.052,1.837-6.793,5.478-6.793,9.3h26.731C138.183,9.494,135.443,5.854,131.393,4.016ZM119.089,9.6a1.394,1.394,0,1,1,1.432-1.395A1.413,1.413,0,0,1,119.089,9.6Zm11.458,0a1.394,1.394,0,1,1,1.432-1.395A1.414,1.414,0,0,1,130.547,9.6Z",
    transform: "translate(-103.429 0)",
    fill: "#57c927"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M30.619,196.667c-1.191,0-2.428-1.124-3.191-2.906v11.393a3.068,3.068,0,0,0,6.111,0v-10.8C32.775,195.787,31.67,196.667,30.619,196.667Z",
    transform: "translate(-27.428 -175.26)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M414.483,158.977a3,3,0,0,0-3.055,2.786v11.928a3.068,3.068,0,0,0,6.111,0V161.764A3,3,0,0,0,414.483,158.977Z",
    transform: "translate(-374.763 -143.797)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(8.023 6.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M414.619,196.667c-1.191,0-2.428-1.124-3.191-2.906v11.393a3.068,3.068,0,0,0,6.111,0v-10.8C416.775,195.787,415.671,196.667,414.619,196.667Z",
    transform: "translate(-382.785 -182.037)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M128.414,163.309c-6.042,0-11.458-.7-12.986-1.691V181.81a2.639,2.639,0,0,0,2.645,2.9h2.181a1.6,1.6,0,0,0-.243.821v5.886a3.068,3.068,0,0,0,6.111,0v-5.886a1.512,1.512,0,0,0-.367-.821h5.32a1.512,1.512,0,0,0-.369.821v5.886a3.068,3.068,0,0,0,6.111,0v-5.886a1.606,1.606,0,0,0-.242-.821h2.184a2.636,2.636,0,0,0,2.641-2.9V161.617C139.872,162.609,134.457,163.309,128.414,163.309Z",
    transform: "translate(-115.048 -152.962)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M131.979,72.409a1.434,1.434,0,0,1-2.866,0,1.365,1.365,0,0,1,.49-1.042,29.541,29.541,0,0,0-9.573,0,1.362,1.362,0,0,1,.491,1.042,1.433,1.433,0,0,1-2.865,0,1.363,1.363,0,0,1,.119-.555,17.324,17.324,0,0,0-5.743,2.56,10.136,10.136,0,0,0-.581,3.1h26.731a10.143,10.143,0,0,0-.581-3.1,17.292,17.292,0,0,0-5.741-2.563A1.384,1.384,0,0,1,131.979,72.409Z",
    transform: "translate(-111.452 -70.977)",
    fill: "#1cb71c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M128.414,237.44c-5.146,0-9.93-1.015-12.986-2.679V247.97a2.639,2.639,0,0,0,2.645,2.9h2.181a1.6,1.6,0,0,0-.243.821v5.886a3.069,3.069,0,0,0,6.111,0v-5.886a1.512,1.512,0,0,0-.367-.821h5.32a1.512,1.512,0,0,0-.369.821v5.886a3.069,3.069,0,0,0,6.111,0v-5.886a1.606,1.606,0,0,0-.242-.821h2.184a2.636,2.636,0,0,0,2.641-2.9V234.761C138.344,236.425,133.56,237.44,128.414,237.44Z",
    transform: "translate(-107.026 -212.345)",
    fill: "#049e42"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidEdge);
export default __webpack_public_path__ + "static/media/androidEdge.5209d7c467692d31a458ab74f58e028b.svg";
export { ForwardRef as ReactComponent };